module.exports = __webpack_public_path__ + "img/stra2.56b6eadb.png";